import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const LightsOffFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M4.63631 20.4668L20.67 4.43295L19.3972 3.16016L16.5508 6.00661C14.9953 5.3286 13.2412 4.92706 11.5601 4.84047C10.5001 7.22047 9.88006 9.78047 9.88006 12.0005C9.88006 12.2172 9.88597 12.4371 9.89762 12.6598L6.91701 15.6405H2.56006V17.6805H4.87703L3.36353 19.194L4.63631 20.4668ZM10.7132 16.9321L19.6325 8.01284C20.7437 9.10196 21.4401 10.4445 21.4401 12.0005C21.4401 16.2605 16.2201 18.9205 11.5601 19.1605C11.2346 18.4296 10.9505 17.6818 10.7132 16.9321ZM2.56006 6.24047H8.12006V8.28047H2.56006V6.24047ZM2.56006 10.9405H8.12006V12.9805H2.56006V10.9405Z"
      />
    </SvgIcon>
  );
});
